import React from 'react';
import './PageStyles.css';

function RefundPolicy() {
  return (
    <div className="page">
      <h1>💳 Refund & Cancellation Policy</h1>

      <p>
        At <strong>TestYodha</strong>, we strive to offer full value through every subscription and service. 
      </p>
      <p>Once a user subscribes to a plan or purchases study material, the transaction is considered final.</p>

      <h2>🔁 No Refund Policy</h2>
      <p>
        All payments made on TestYodha are <strong>non-refundable</strong>. We encourage users to review the plan details thoroughly before proceeding with payment.
      </p>

      <h2>🚫 No Cancellation After Activation</h2>
      <p>
        Once a plan is activated, it cannot be cancelled or transferred. Access to premium content begins instantly after payment, which makes cancellation ineligible.
      </p>

      <h2>📩 Facing Issues?</h2>
      <p>
        If you experience any technical issues or payment-related concerns, please contact us at:
        <br />
        <a href="mailto:testyodha3@gmail.com" style={{ color: '#0047ab' }}>
          testyodha3@gmail.com
        </a>
        <br />
        We’re here to help you within 24–48 business hours.
      </p>

      <hr style={{ margin: '40px auto', width: '60%', borderColor: '#444' }} />

      <p style={{ fontStyle: 'italic', color: '#25292e' }}>
        Your trust matters to us. We’re committed to ensuring a smooth and fair experience on TestYodha.
      </p>
    </div>
  );
}

export default RefundPolicy;